<template>
    <div>
        <el-upload class="avatar-uploader" :action="uploadAction" :limit="1" name="image" :data="uploadData"
            :headers="uploadHeader" :show-file-list="false" :on-success="handleAvatarSuccess" accept="image/*">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <div v-else class="avatar flex-col flex-xy-center">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <span class="fs14">{{ config.name || '请上传图片' }}</span>
            </div>

        </el-upload>
    </div>
</template>

<script>
import { objKeySort } from '@/utils/auth'
import { getStorage } from '@/utils/auth'
export default {
    name: 'FromImage',
    components: {

    },
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        imageUrl(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.imageUrl = value
        }
    },
    data() {
        return {
            uploadAction: process.env.VUE_APP_BASE_API + 'common/uploadImage',
            uploadHeader: { Authorization: getStorage('token') },
            uploadData: {
                sign: objKeySort([])[2]
            },
            imageUrl: this.value
        }
    },
    methods: {
        handleAvatarSuccess(res, file) {
            console.log(res, file)
            this.imageUrl = res.data
        }
    }
}
</script>

<style lang="scss" scoped>
.avatar-uploader {
    /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: #fbfdff;
    }

    &-icon {
        font-size: 30px;
        color: #8c939d;
        width: 120px;
        text-align: center;
        margin-top: 30px;
    }
}

.avatar {
    width: 120px;
    height: 120px;
    display: block;
}
</style>